import { reactive, computed } from '@vue/composition-api'
import * as _ from 'lodash'

export const ServiceLicenseCancelInputInvalidUser = (props, context) => {
  const store = context.root.$store

  const shortageList = computed(() => store.getters['cancellation/getLicenseShortage'])
  // ライセンス付与中のユーザーリスト作成
  const emptyAry = reactive([...Array(shortageList.value.length).keys()])
  const activeUsers = reactive(_.map(emptyAry, list => {
    const usingLicense = shortageList.value[list].using_license
    return _.map(usingLicense, 'user_id')
  }))

  const isNoShortage = () => {
    return _.every(emptyAry, index => {
      return activeUsers[index].length <= shortageList.value[index].afterNum
    })
  }

  const close = () => {
    context.emit('closeServiceLicenseCancelInputInvalidUser')
  }
  const submit = () => {
    context.emit('closeServiceLicenseCancelInputInvalidUser')
  }

  /**
   * 確認画面を表示する
   * （「設定」ボタンを押した時）
   */
  const openViewConfirm = () => {

    // チェックを外したユーザのリストを生成
    const userToDisable = _.map(shortageList.value, (product, index) => {
      const list = {}
      list.code = product.code
      const userIds = _.map(product.using_license, 'user_id')
      list.users = _.without(userIds, ...activeUsers[index])

      return list
    })

    context.emit('openViewConfirm', userToDisable)
  }

  return {
    close,
    submit,
    openViewConfirm,
    shortageList,
    activeUsers,
    isNoShortage
  }
}
